import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '98.css'

createApp(App).use(router).mount('#app')
